// /moto — Titan Motorcycle · Service Shop
// Thin wrapper on the shared VerticalCockpit chassis.
// Skin: chrome/shop — gunmetal + chrome silver + shop-floor blue.
import VerticalCockpit from "@/components/VerticalCockpit";
import { PALETTES } from "@/config/AssetSpine";
import { VERTICAL_CONFIG } from "@/config/verticalConfig";

export default function MotoFoyer() {
  return (
    <VerticalCockpit
      config={VERTICAL_CONFIG.MOTO}
      palette={PALETTES.MOTO}
      testPrefix="mt"
    />
  );
}
